<template>
  <!--生日祝福页面-->
  <tk-container
    :status="status"
    :probeType="3"
    hide-status-bar
    :style="{background: bgColor}"
    @refresh="refreshInit"
    @scroll="watchScroll"
  >
    <!--头部-->
    <gradient-header slot="header" :z-index="zIndex" :is-show-back="true"
                     :is-header-color="isHeaderColor" :back-style="isHeaderColor ? false : true" :icon-name="'return'">
      <div slot="center-menu" :style="{color: isHeaderColor ? '#000000' : '#fff'}">生日祝福</div>
    </gradient-header>
    <!--背景图渲染-->
    <div class="limited-bg" :style="`background-image: url(${bgSrc}) !important`"></div>
    <!--用户列表-->
    <div class="m-x-12 birthday-user">
      <!--当天过生日的用户-->
      <linear-card
        class="p-x-12 p-b-24"
        :width="100" :height="204"
        :title="'今天是Ta的生日'"
        :font-size="14"
        :is-more="false"
        :linear-top-color="'rgba(255, 255, 255, 0)'"
        :linear-bottom-color="'rgba(255, 255, 255, 0)'"
      >
        <div v-if="todayBirthUser.length">
          <tk-flex wrap>
            <tk-flex
              class="tk-grid-4 m-t-20"
              v-for="(s, index) in todayBirthUser"
              :key="`birthday-user${index}`"
              :center="index === (parseInt(index / 3) + 1) +
               parseInt(index / 3) * 2"
              :right="index === ((parseInt(index / 3) + 1) +
               parseInt(index / 3) * 2) + 1"
            >
              <tk-flex
                center middle column
              >
                <div class="birth-avatar" style="position: relative;">
                  <tk-avatar size="67">
                    <tk-image :src="s.avatar ? s.avatar : defaultImage" :width="67" :height="67"></tk-image>
                  </tk-avatar>
                  <div class="birth-crown">
                    <tk-image :src="crownImage" width="23" height="19"></tk-image>
                  </div>
                </div>
                <div class="m-t-10 font-14">{{s.name}}</div>
                <div class="m-t-15">
                  <tkui-button
                    @click.native="giveAway(s)"
                    class="today-btn primary raised rounded small"
                  >
                    送Ta礼物
                  </tkui-button>
                </div>
              </tk-flex>
            </tk-flex>
          </tk-flex>
        </div>
        <empty-tips v-else :height="204" :empty-msg="'今天没有过生日的用户'"></empty-tips>
      </linear-card>
      <!--未来7天内过生日的用户-->
      <linear-card
        class="p-x-12 p-b-24 m-t-10"
        :width="100" :height="104"
        :title="'这些朋友即将生日'"
        :font-size="14"
        :is-more="false"
        :linear-top-color="'rgba(255, 255, 255, 0)'"
        :linear-bottom-color="'rgba(255, 255, 255, 0)'"
      >
        <div v-if="day7BirthUser.length">
          <tk-flex
            middle
            class="m-t-20"
            between
            v-for="(s, index) in day7BirthUser"
            :key="index"
          >
            <tk-flex middle>
              <div class="birth-avatar" style="position: relative;">
                <tk-avatar size="67">
                  <tk-image :src="s.avatar ? s.avatar : defaultImage" :width="67" :height="67"></tk-image>
                </tk-avatar>
              </div>
              <div class="m-l-15">
                <div class="font-14">{{s.name}}</div>
                <div class="m-t-12 caption">
                  {{s.birthdayType | birthType}}
                  <span class="m-l-5">{{s.birthday | date}}</span>
                </div>
              </div>
            </tk-flex>
            <tkui-button
              @click.native="giveAway(s)"
              class="eleven-btn primary raised rounded small"
            >
              送礼物
            </tkui-button>
          </tk-flex>
        </div>
        <empty-tips v-else :height="104" :empty-msg="'7天内没有过生日的用户'"></empty-tips>
      </linear-card>
    </div>
    <div style="height: 20px;"></div>
    <!--送礼物弹框-->
    <tk-cover
      :show.sync="isShowGive"
      center
      bottom
      transition
    >
      <div class="give-card">
        <div class="card-title primary">
          <div class="p-15">送礼物</div>
        </div>
        <tk-flex
          middle
          between
          style="line-height: 1;"
          class="m-t-10 p-l-15"
        >
          <tk-flex middle class="tk-grid-7">
            <tk-image class="m-t-2" :src="'https://s3.moke.cloud/dianpei/200429df-6a95-4243-b7ab-5ae792bd3efd.png'" width="18" height="18"></tk-image>
            <div class="font-14 p-l-15 font-bold m-t-2">幸运星</div>
            <div class="caption m-l-10" style="margin-top: 1px;">拥有{{luckStarSum}}个</div>
          </tk-flex>
          <tkui-input class="tk-grid-5 cover-input" noborder mask="natural" place-holder="请输入赠送数量" v-model="starInput"></tkui-input>
        </tk-flex>
        <tk-flex
          middle
          between
          style="line-height: 1;"
          class="p-l-15"
        >
          <tk-flex middle class="tk-grid-7">
            <tk-image class="m-t-2" :src="'https://s3.moke.cloud/dianpei/f4f7251e-085a-4c31-b41f-bd8b3afd5937.png'" width="18" height="18"></tk-image>
            <div class="font-14 p-l-15 font-bold m-t-2">欢乐豆</div>
            <div class="caption m-l-10" style="margin-top: 1px;">拥有{{happyBeanSum}}个</div>
          </tk-flex>
          <tkui-input class="tk-grid-5 cover-input" noborder mask="natural" place-holder="请输入赠送数量" v-model="happyBeanInput"></tkui-input>
        </tk-flex>
        <tk-flex middle between class="p-l-20 p-r-20 m-t-15">
          <tk-flex middle>
            <div class="caption"><span class="font-14">送给</span></div>
            <div v-if="selectedUser" class="m-l-15">
              <tk-avatar size="30">
                <tk-image :src="selectedUser.avatar ? selectedUser.avatar : defaultImage" width="30" height="30"></tk-image>
              </tk-avatar>
            </div>
          </tk-flex>
          <tkui-button
            :disabled="isGiveDisabled"
            @click.native="submitGive(selectedUser)"
            class="eleven-btn primary raised rounded small"
          >
            确定
          </tkui-button>
        </tk-flex>
      </div>
    </tk-cover>
  </tk-container>
</template>

<script>
import { addRevenue } from '@/assets/help/tool'
import solarLunar from 'solarlunar'
import linearCard from '@/components/linearCard'
const crownImage = 'https://s3.moke.cloud/dianpei/9ef9a899-c4e8-4a90-92e5-5e92d9e559a4.png'
export default {
  components: {
    linearCard
  },
  data () {
    return {
      status: 'loading', // 页面状态
      zIndex: 100, // 头部层
      isGiveDisabled: false, // 防抖状态
      isHeaderColor: false, // 判断头部颜色切换
      isShowGive: false, // 赠送礼物弹框显示
      themeBackground: null, // 主题背景图片
      wallet: null, // 钱包数据
      crownImage: crownImage, // 皇冠图片
      selectedUser: null, // 选定送礼物的用户
      todayBirthUser: [], // 当天过生日的用户
      day7BirthUser: [], // 未来7天过生日的用户
      starInput: '', // 输入幸运星数量
      happyBeanInput: '' // 输入欢乐豆数量
    }
  },
  beforeRouteLeave (to, from, next) {
    this.setStatusBar('dark')
    next(true)
  },
  activated () {
    this.setStatusBar('light')
  },
  mounted () {
    this.getInit()
  },
  filters: {
    birthType (val) {
      return val === 'lunar' ? '农历' : '阳历'
    }
  },
  computed: {
    // 背景图src
    bgSrc () {
      if (!this.themeBackground || (this.themeBackground && !this.themeBackground.image)) { return '' }
      return this.themeBackground.image
    },
    // 背景颜色
    bgColor () {
      if (!this.themeBackground || (this.themeBackground && !this.themeBackground.bgColor)) { return '' }
      return this.themeBackground.bgColor
    },
    // 幸运星数量
    luckStarSum () {
      if (!this.wallet || (this.wallet && !this.wallet.luckyStar)) { return 0 }
      return this.wallet.luckyStar
    },
    // 欢乐豆
    happyBeanSum () {
      if (!this.wallet || (this.wallet && !this.wallet.happyBean)) { return 0 }
      return this.wallet.happyBean
    }
  },
  methods: {
    /**
     * 数据初始化
     * @date: 2020/4/11
     */
    async getInit () {
      try {
        await this.getThemeBackground() // 获取主题图片
        await this.getTodayBirthday() // 获取今天过生日的用户
        await this.get7Birthday() // 获取未来7天过生日的用户
        await this.getWallet() // 获取用户钱包
        this.status = false
      } catch (e) {
        this.status = 'error'
        this.$tkGlobal.toast.add('加载数据失败')
      }
    },
    /**
     * 监听页面滚动改变头部背景颜色
     * @date: 2020/3/26
     */
    watchScroll (scrollTop) {
      this.isHeaderColor = scrollTop > 12
      this.setStatusBar(this.isHeaderColor ? 'dark' : 'light')
      this.$forceUpdate()
    },
    /**
     * 页面错误时点击重新加载按钮 @resetInfiniteScroll
     * @date: 2020/3/24
     */
    async refreshInit () {
      await this.getInit()
    },
    /**
     * 获取主题图片
     * @date: 2020/4/11
     */
    async getThemeBackground () {
      let themeBackground = await this.$tkParse.getList('/classes/themeBackground', {
        params: {
          limit: 1,
          order: '-createdAt',
          where: {
            position: 'birthdayWishes'
          }
        }
      })
      if (themeBackground.length) { this.themeBackground = themeBackground[0] } else {
        this.themeBackground = null
      }
    },
    /**
    * 返回今天阳历·农历零点到二十四点的时间
    * solarToLunar 公历转农历 lunarToSolar 农历转公历
    * @date: 2020/4/24
    */
    getTodayPeriod () {
      // 获取公历今天年月日
      let date = new Date()
      let sYear = date.getFullYear(); let sMonth = date.getMonth() + 1; let sDay = date.getDate()
      let solar2lunarData = solarLunar.solar2lunar(sYear, sMonth, sDay)
      // 获取农历今天年月日
      let lYear = solar2lunarData.lYear; let lMonth = solar2lunarData.lMonth; let lDay = solar2lunarData.lDay
      let lDate = [[Number((lYear.toString())), lMonth, lDay].join('/')].join(' ').replace(/(?=\b\d\b)/g, '0')
      // 当天公历时间段
      let sStartTime = new Date(this.$tkDate().startOf('day').toISOString())
      let sEndTime = new Date(this.$tkDate().endOf('day').toISOString())
      // 当天农历时间段
      let lStartTime = new Date(this.$tkDate(lDate).startOf('day').toISOString())
      let lEndTime = new Date(this.$tkDate(lDate).endOf('day').toISOString())
      // 公历未来七天的结束时间
      let s7Day = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 7 * 60 * 60 * 1000)
      let s7EndDateTime = new Date(this.$tkDate(s7Day).endOf('day').toISOString())
      // 农历未来七天的结束时间
      let l7Day = new Date(new Date(new Date(lDate).toLocaleDateString()).getTime() + 24 * 7 * 60 * 60 * 1000)
      let l7EndDateTime = new Date(this.$tkDate(l7Day).endOf('day').toISOString())
      return {
        sStartTime: sStartTime, // 当天公历开始时间
        sEndTime: sEndTime, // 当天公历结束时间
        lStartTime: lStartTime, // 当天农历开始时间
        lEndTime: lEndTime, // 当天农历结束时间
        s7EndDateTime: s7EndDateTime, // 公历7天后的结束时间
        l7EndDateTime: l7EndDateTime // 农历7天后的结束时间
      }
    },
    /**
    * 请求用户接口
    * @date: 2020/4/26
    */
    async getParseUser (type, birthDayMonthDay) {
      // eslint-disable-next-line no-return-await
      return await this.$tkParse.getList('/classes/_User', {
        params: {
          limit: 1000,
          where: {
            objectId: {
              $ne: this.userInfo.objectId
            },
            birthdayType: type,
            accountCategory: 'countyAccount',
            birthDayMonthDay: birthDayMonthDay
          }
        }
      })
    },
    /**
    * 获取今天过生日的用户 calendar 公历 lunar 农历
    * @date: 2020/4/24
    */
    async getTodayBirthday () {
      let dateObj = this.getTodayPeriod()
      let sUser = await this.getParseUser('calendar',
        Number((new Date(dateObj.sStartTime).getMonth() + 1).toString() +
          (new Date(dateObj.sStartTime).getDate() < 10 ? '0' + new Date(dateObj.sStartTime).getDate().toString() : new Date(dateObj.sStartTime).getDate().toString())))
      let lUser = await this.getParseUser('lunar',
        Number((new Date(dateObj.lStartTime).getMonth() + 1).toString() +
          (new Date(dateObj.lStartTime).getDate() < 10 ? '0' + new Date(dateObj.lStartTime).getDate().toString() : new Date(dateObj.lStartTime).getDate().toString())))
      let todayBirthUser = [...sUser, ...lUser]
      if (todayBirthUser.length) { this.todayBirthUser = todayBirthUser } else { this.todayBirthUser = [] }
    },
    /**
    * 获取未来7天过生日的用户 calendar 公历 lunar 农历
    * @date: 2020/4/26
    */
    async get7Birthday () {
      let dateObj = this.getTodayPeriod()
      let sStart = Number((new Date(dateObj.sStartTime).getMonth() + 1).toString() +
        (new Date(dateObj.sStartTime).getDate() < 10 ? '0' + new Date(dateObj.sStartTime).getDate().toString() : new Date(dateObj.sStartTime).getDate().toString()))
      let sEnd = Number((new Date(dateObj.s7EndDateTime).getMonth() + 1).toString() +
        (new Date(dateObj.s7EndDateTime).getDate() < 10 ? '0' + new Date(dateObj.s7EndDateTime).getDate().toString() : new Date(dateObj.s7EndDateTime).getDate().toString()))
      let lStart = Number((new Date(dateObj.lStartTime).getMonth() + 1).toString() +
        (new Date(dateObj.lStartTime).getDate() < 10 ? '0' + new Date(dateObj.lStartTime).getDate().toString() : new Date(dateObj.lStartTime).getDate().toString()))
      let lEnd = Number((new Date(dateObj.l7EndDateTime).getMonth() + 1).toString() +
        (new Date(dateObj.l7EndDateTime).getDate() < 10 ? '0' + new Date(dateObj.l7EndDateTime).getDate().toString() : new Date(dateObj.l7EndDateTime).getDate().toString()))
      let sUser = await this.getParseUser('calendar', { $gt: sStart, $lte: sEnd })
      let lUser = await this.getParseUser('lunar', { $gt: lStart, $lte: lEnd })
      let day7BirthUser = [...sUser, ...lUser]
      if (day7BirthUser.length) { this.day7BirthUser = day7BirthUser } else { this.day7BirthUser = [] }
    },
    /**
     * 获取用户钱包
     * @date: 2020/4/11
     */
    async getWallet () {
      let wallet = await this.$tkParse.getList('/classes/wallet', {
        params: {
          limit: 1,
          where: {
            user: this.userInfo.objectId
          }
        }
      })
      if (wallet.length) { this.wallet = wallet[0] } else { this.wallet = null }
    },
    /**
    * 赠送礼物
    * @date: 2020/4/26
    */
    giveAway (birthUser) {
      this.selectedUser = birthUser
      this.starInput = ''
      this.happyBeanInput = ''
      this.isShowGive = true
    },
    /**
     * 赠送幸运星 赠送欢乐豆
     * @date: 2020/4/20
     */
    async consumeStarBean (starSum, happyBeanNum, birthUser) {
      let obj = {}
      if (this.luckStarSum) { obj.luckyStar = this.wallet.luckyStar - starSum }
      if (this.happyBeanSum) { obj.happyBean = this.wallet.happyBean - happyBeanNum }
      // 修改钱包信息
      await this.$tkParse.put(`/classes/wallet/${this.wallet.objectId}`, obj)
      let birthWallet = null
      let res = await this.$tkParse.getList(`/classes/wallet`, {
        params: {
          limit: 1,
          where: {
            user: birthUser.objectId
          }
        }
      })
      if (!res.length) {
        let res = await this.$tkParse.post('/classes/wallet', {
          user: birthUser.objectId,
          luckyStar: 0,
          happyBean: 0
        })
        birthWallet = await this.$tkParse.getData(`/classes/wallet/${res.data.objectId}`)
      } else {
        birthWallet = res[0]
      }
      await this.$tkParse.put(`/classes/wallet/${birthWallet.objectId}`, {
        luckyStar: birthWallet.luckyStar + starSum,
        happyBean: birthWallet.happyBean + happyBeanNum
      })
      // 添加收支明细 income  expenditure
      if (starSum) {
        await addRevenue('luckyStarRecords', this.userInfo.objectId, `生日赠送给${birthUser.name}${starSum}个幸运星`, starSum, 'expenditure', this.wallet.luckyStar - starSum)
        await addRevenue('luckyStarRecords', birthUser.objectId, `生日${this.userInfo.name}赠送${starSum}个幸运星`, starSum, 'income', birthWallet.luckyStar + starSum)
      }
      if (happyBeanNum) {
        await addRevenue('happyBeanRecords', this.userInfo.objectId, `生日赠送给${birthUser.name}${happyBeanNum}个欢乐豆`, happyBeanNum, 'expenditure', this.wallet.happyBean - happyBeanNum)
        await addRevenue('happyBeanRecords', birthUser.objectId, `生日${this.userInfo.name}赠送${happyBeanNum}个欢乐豆`, happyBeanNum, 'income', birthWallet.happyBean + happyBeanNum)
      }
    },
    /**
    * 提交赠送
    * @date: 2020/4/26
    */
    async submitGive (birthUser) {
      // 欢乐豆幸运星数量判断
      let starSum = 0
      let happyBeanNum = 0
      await this.getWallet()
      if (!this.starInput) { starSum = 0 } else { starSum = Number(this.starInput) }
      if (!this.happyBeanInput) { happyBeanNum = 0 } else { happyBeanNum = Number(this.happyBeanInput) }
      if (!starSum && !happyBeanNum) { return this.$tkGlobal.toast.add('没找到您要赠送的礼物') }
      if (starSum > this.luckStarSum) { return this.$tkGlobal.toast.add('您的幸运星不够了') }
      if (happyBeanNum > this.happyBeanSum) { return this.$tkGlobal.toast.add('您的欢乐豆不够了') }
      if (!birthUser) { return this.$tkGlobal.toast.add('未找到您要赠送的用户') }
      if (this.isGiveDisabled) { return this.$tkGlobal.toast.add('您点的太快了') }
      this.isGiveDisabled = true
      this.isShowGive = false
      this.status = 'waiting'
      // 修改钱包信息
      await this.$cloudAjax.post('/birthday/$consumeStarBean', {
        userId: this.userInfo.objectId,
        starSum: starSum,
        happyBeanNum: happyBeanNum,
        birthUser: birthUser
      }).catch(e => {
        this.isGiveDisabled = false
        this.status = false
        throw this.$tkGlobal.toast.add(e.data ? e.data : '请求失败')
      })
      // 更新钱包信息
      await this.getWallet() // 获取用户钱包
      await this.$tkHelper.sleep(500)
      this.isGiveDisabled = false
      this.$tkGlobal.toast.add('您的祝福已送达')
      this.status = false
    }
  }
}
</script>

<style scoped lang="scss">
  /*背景图样式*/
  .limited-bg {
    width: 100%;
    min-height: 233px;
    padding-top: 60px;
    background-repeat:  no-repeat;
    background-size: 100% 100%;
  }
  /*头像样式*/
  .birth-avatar {
    width: 73px;
    height: 73px;
    border: 3px solid #FEC337;
    border-radius: 50%;
    .birth-crown {
      width: 23px;
      height: 19px;
      position: absolute;
      top: -10px;
      left: 0;
    }
  }
  /*title样式*/
  .birthday-user {
    ::v-deep .class-card-style {
      padding: 8px 0 !important;
    }
  }
  /*当天生日按钮样式*/
  .today-btn {
    min-width: 90px !important;
    height: 24px !important;
    background-color: rgba(254, 195, 55, 1) !important;
    border-radius: 12px !important;
    margin: 0;
    box-shadow:0 8px 30px 0 rgba(245, 161, 0, 0.35);
  }
  /*未来七天按钮样式*/
  .eleven-btn {
    min-width: 64px;
    height: 30px;
    line-height: 30px;
    border-radius: 15px;
    margin: 0;
    background:linear-gradient(90deg,rgba(255,56,67,1),rgba(254,102,0,1));
  }
  /*送礼物弹框样式*/
  .give-card {
    width: 100vw;
    min-height: 280px;
    background: #fff;
    border-top-left-radius: 15px;
    border-top-right-radius: 15px;
    .card-title {
      font-size: 14px;
      font-weight: bold;
      text-align: center;
      border-bottom: 1px solid #f5f5f5;
    }
    .cover-input {
      font-size: 14px;
      ::placeholder {
        line-height: 1;
        color: #c5c5c5 !important;
      }
    }
  }
</style>
